import {
  Person as PersonIcon,
  Badge as BadgeIcon,
  Wc as GenderIcon,
  Cake as CakeIcon,
  FamilyRestroom as FamilyIcon,
  Favorite as HeartIcon,
  AssignmentInd as AssignmentIcon,
} from "@mui/icons-material";
import { useContextContrato } from "src/Contexts/Lancamentos/Contrato/ContratosContext";
import { FormatDateBR } from "src/shared/Utils/FormatDateBR";
import { ModernCard } from "./shared/ModernCard";
import { ModernInfoItem } from "./shared/ModernInfoItem";
import { ModernGridInfo } from "./shared/ModernGridInfo";

export const CardDadosTitularModern = () => {
  const { valueContractInternal } = useContextContrato();

  if (!valueContractInternal) return null;

  const {
    tipo_contrato,
    titular_pf,
    cpf_cnpj,
    rg_pf,
    estado_civil_pf,
    data_nacimento_pf,
    genero_pf,
    mae_pf,
    data_nascimento_responsavel_pf,
    cpf_responsavel_pf,
    responsavel_pf,
  } = valueContractInternal;

  if (tipo_contrato !== "PF") return null;

  return (
    <ModernCard title="Dados do Titular" icon={<PersonIcon />}>
      <ModernGridInfo columns={2}>
        <ModernInfoItem
          icon={<PersonIcon />}
          label="Titular"
          value={titular_pf}
        />
        <ModernInfoItem
          icon={<BadgeIcon />}
          label="CPF"
          value={cpf_cnpj}
        />
        <ModernInfoItem
          icon={<AssignmentIcon />}
          label="RG"
          value={rg_pf}
        />
        <ModernInfoItem
          icon={<HeartIcon />}
          label="Estado Civil"
          value={estado_civil_pf?.toUpperCase()}
        />
        <ModernInfoItem
          icon={<CakeIcon />}
          label="Data de Nascimento"
          value={FormatDateBR(data_nacimento_pf)}
        />
        <ModernInfoItem
          icon={<GenderIcon />}
          label="Gênero"
          value={genero_pf}
        />
        <ModernInfoItem
          icon={<FamilyIcon />}
          label="Nome da Mãe"
          value={mae_pf}
          fullWidth
        />
      </ModernGridInfo>

      {/* Dados do responsável (se houver) */}
      {responsavel_pf && (
        <ModernGridInfo columns={2}>
          <ModernInfoItem
            icon={<PersonIcon />}
            label="Responsável"
            value={responsavel_pf}
          />
          <ModernInfoItem
            icon={<BadgeIcon />}
            label="CPF do Responsável"
            value={cpf_responsavel_pf}
          />
          <ModernInfoItem
            icon={<CakeIcon />}
            label="Nascimento Responsável"
            value={FormatDateBR(data_nascimento_responsavel_pf)}
          />
        </ModernGridInfo>
      )}
    </ModernCard>
  );
};
